import { parse } from 'query-string';
import { NotificationServerActionCreators } from '../actions/NotificationServerActionCreators';
import { NotificationClientActionCreators } from '../actions/NotificationClientActionCreators';
import { NotificationActions as NotificationActionTypes } from '../constants/NotificationActions';

import { dataMultiLoader, dataLoader } from '../../utilities/dataLoader';
import { makeMetricsLogEvent } from '../../../ReduxStorage/Metrics/manualEventDispatchers';

const setClickedNotificationChecked = () => (dispatch) => {
  const linkedNotificationDataNodes = dataMultiLoader(
    'linked-notification-data'
  );
  if (linkedNotificationDataNodes.length) {
    const linkedNotificationData = linkedNotificationDataNodes[0];
    if (
      linkedNotificationData.lastCheckedTime <
      linkedNotificationData.lastEventTime
    ) {
      NotificationClientActionCreators.setNotificationChecked(
        linkedNotificationData.channelId,
        linkedNotificationData.subscriptionId,
        linkedNotificationData.lastEventTime
      );
    }
    dispatch(
      makeMetricsLogEvent('Notification-Viewed', {
        emitterType: linkedNotificationData.emitterType,
        actionType: linkedNotificationData.actionType,
        emitterId: linkedNotificationData.emitterId,
        // Old links without the parameter notificationClientType are almost certain to be emails
        clientType:
          parse(window.location.search, true).notificationClientType || 'email',
        wasUnread:
          linkedNotificationData.lastCheckedTime <
          linkedNotificationData.lastEventTime,
      })
    );
  }
};

export const NotificationInitialiser = {
  initialise: () => (dispatch) => {
    const initialSeenTime = dataLoader('initial-notifications-seen-time-data');
    if (initialSeenTime) {
      NotificationServerActionCreators.updateLastSeenTime(initialSeenTime);
    }

    NotificationClientActionCreators.getSettings();

    // Load the unread count (up to 5) on page load for the top bar
    NotificationClientActionCreators.loadMoreNotifications(
      NotificationActionTypes.ACTION_ALL,
      false,
      5
    );

    // If this page was loaded by clicking on a notification, set it as checked
    dispatch(setClickedNotificationChecked());
  },
};
